import * as React from 'react';
import cx from 'classnames';
import TextFieldWithClear from 'components/TextFieldWithIcon/TextFieldWithIcon';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
const styles = require('./styles.pcss');
import CustomSelect from 'components/Inputs/Select/Select';
import { connectWithRouter } from 'helpers/connectWithRouter';

class HotelsRecordForm extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      itineraryId: '',
      confirmationNumber: '',
      provider: '',
    };
  }

  componentDidMount = () => {
    this.onSubmitForm('initial');
  };

  onChangeItineraryId = (event: any) => {
    this.setState({
      itineraryId: event.target.value,
    });
  };

  onChangeConfirmationNumber = (event: any) => {
    this.setState({
      confirmationNumber: event.target.value,
    });
  };

  onChangeProvider = (event: any) => {
    this.setState({
      provider: event.target.value,
    });
  };

  clearItineraryId = () => {
    this.setState({
      itineraryId: '',
    });
  };

  clearConfirmationNumber = () => {
    this.setState({
      confirmationNumber: '',
    });
  };

  onSubmitForm = (initial?: any) => {
    let req: any = {
      itineraryId: this.state.itineraryId,
      confirmationNumber: this.state.confirmationNumber,
      provider: this.state.provider,
    };

    let url = 'lookup?type=booking&bookingtype=hotel';

    if (initial == 'initial') {
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.get('itineraryId')) {
        req.itineraryId = urlParams.get('itineraryId');
      }

      if (urlParams.get('confirmationNumber')) {
        req.confirmationNumber = urlParams.get('confirmationNumber');
      }

      if (urlParams.get('provider')) {
        req.provider = urlParams.get('provider');
      }

      this.setState({
        itineraryId: req.itineraryId,
        confirmationNumber: req.confirmationNumber,
        provider: req.provider,
      });
    } else {
      if (this.state.itineraryId) {
        url += `&itineraryId=${encodeURIComponent(this.state.itineraryId)}`;
      }

      if (this.state.confirmationNumber) {
        url += `&confirmationNumber=${encodeURIComponent(
          this.state.confirmationNumber,
        )}`;
      }

      if (this.state.provider) {
        url += `&provider=${encodeURIComponent(this.state.provider)}`;
      }

      if (this.props.navigate) {
        this.props.navigate(`/${url}`);
      }
    }

    this.props.onSubmit(req);
  };

  _getSearchButtonText = () => {
    return 'Search';
  };

  onKeyPressed = (e: any) => {
    if (e.key === 'Enter') {
      this.onSubmitForm();
    }
  };

  render() {
    return (
      <div
        className={styles.form}
        onKeyDown={(e) => this.onKeyPressed(e)}
      >
        <div className={styles.inputWrapper}>
          <TextFieldWithClear
            onChange={this.onChangeItineraryId}
            label="Itinerary Id"
            variant="outlined"
            margin="normal"
            value={this.state.itineraryId}
            onClear={this.clearItineraryId}
            fullWidth={true}
          />
        </div>

        <div className={styles.inputWrapper}>
          <TextFieldWithClear
            onChange={this.onChangeConfirmationNumber}
            label="Hotel Conf #"
            variant="outlined"
            margin="normal"
            value={this.state.confirmationNumber}
            onClear={this.clearConfirmationNumber}
            fullWidth={true}
          />
        </div>

        <div className={styles.inputWrapper}>
          <CustomSelect
            margin={'normal'}
            variant={'outlined'}
            className={styles.selectWrapper}
            disabled={this.props.readOnly}
            htmlFor={'input-type'}
            label={'Provider'}
            id={'input-type'}
            value={this.state.provider}
            onChange={this.onChangeProvider}
            fullWidth={true}
            inputName={'type'}
            MenuProps={{
              style: { marginTop: 4, boxShadow: 'none' },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
            menuItems={[
              {
                key: 'expedia',
                value: 'expedia',
                label: 'Expedia',
              },
              {
                key: 'travelport',
                value: 'travelport',
                label: 'Travelport',
              },
            ]}
          />
        </div>
        <div className={styles.inputWrapper}>
          <Button
            fullWidth
            className={styles.button}
            variant="contained"
            color="primary"
            onClick={this.onSubmitForm}
          >
            {this._getSearchButtonText()}
          </Button>
        </div>
      </div>
    );
  }
}

export default connectWithRouter()(HotelsRecordForm);
